import { webappClient } from "./clients";

const TOKENS_API_URL = "api/tokens";

export async function fetchTokens(): Promise<any> {
  return webappClient.get(TOKENS_API_URL).json();
}
